import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import FormInput from '../../components/form/FormInput';
import FormTextarea from '../../components/form/FormTextarea';
import { convertToMask } from '../../utils/common';
import { useUserDetails } from '../../store/slices/authSlice';
import whatsappIcon from '../../assets/images/icons/whatsapp.svg';
import { useDispatch } from 'react-redux';
import {
  setActiveHelpDetails,
  whatsappAddDetails
} from '../../store/slices/tenantSlices/helpDeskSlice';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Information = ({ data, onUpdate }) => {
  const { t } = useTranslation();
  const user = useUserDetails();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [comment, setComment] = useState(data?.comment || ''); // Initialize with data.comment if available

  useEffect(() => {
    if (onUpdate) {
      onUpdate({ ...data, comment });
    }
  }, [comment]);

  const addNumber = async () => {
    try {
      const payload = { from: `91${data?.primaryNumber}@c.us`, name: data?.primaryNumber };
      const response = await dispatch(whatsappAddDetails(payload)).unwrap();
      if (response && response?.message) {
        dispatch(
          setActiveHelpDetails({
            ...response?.data,
            id: response?.data?._id,
            name: response?.data?.from_name,
            activeTab: response?.data?.assignedToId ? 'mine' : 'unassigned'
          })
        );
        navigate('/help-desk');
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  return (
    <Row xs="3">
      <FormInput
        label={t('primaryNumber')}
        name="primaryNumber"
        isIcon={user?.userWhatsappPermission}
        icon={
          <img
            src={whatsappIcon}
            width={20}
            height={20}
            className="cursor-pointer"
            onClick={() => addNumber()}
          />
        }
        value={
          user?.process_details?.numberMasking === 'true'
            ? convertToMask(data?.primaryNumber)
            : data?.primaryNumber
        }
        disabled
      />
      {/* 
        <FormInput
          label="Secondary Number"
          name="secondaryNumber"
          value={data?.secondaryNumber}
          disabled
        />
        <FormInput
          label="Tertiary Number"
          name="tertiaryNumber"
          value={data?.tertiaryNumber}
          disabled
        />
      */}
      <Col xs="8">
        <FormTextarea
          label={t('comment')}
          name="comment"
          value={comment}
          rows={1}
          placeholder={t('enterComment')}
          onChange={(e) => setComment(e.target.value)}
        />
      </Col>
    </Row>
  );
};

Information.propTypes = {
  data: PropTypes.object,
  onUpdate: PropTypes.func.isRequired
};

export default Information;
